import { render, staticRenderFns } from "./UserInformation.vue?vue&type=template&id=2d3a0ff8&scoped=true&"
import script from "./UserInformation.vue?vue&type=script&lang=js&"
export * from "./UserInformation.vue?vue&type=script&lang=js&"
import style0 from "./UserInformation.vue?vue&type=style&index=0&id=2d3a0ff8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3a0ff8",
  null
  
)

export default component.exports